/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Socket.io]
-------------------------------------------------------------------*/
import io from "socket.io-client";
/*------------------------------------------------------------------
[End Socket.io]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_POST, API_URL, API_SERVER, API_SCT } from '../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { console_dev, random_character } from '../../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Etc]
-------------------------------------------------------------------*/
import OverlayBg from '../../../assets/img/overlay_bg_form.png'
/*------------------------------------------------------------------
[End Etc]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Veriable]
-------------------------------------------------------------------*/
let SOCKET_SERVER = process.env.REACT_APP_PRODUCTION === 'false' ? process.env.REACT_APP_SOCKET_SERVER_DEVELOPMENT : process.env.REACT_APP_SOCKET_SERVER_PRODUCTION;
let socket = io(SOCKET_SERVER);
/*------------------------------------------------------------------
[End Variable]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [refresh, set_refresh] = useState(false);
    const [bamboo_user, set_bamboo_user] = useState(null);
    const [file, set_file] = useState(null);
    const [element, set_element] = useState(null);
    const [sub_element, set_sub_element] = useState(null);
    const [pagination_active, set_pagination_active] = useState(1);
    const [data, set_data] = useState(null);
    const [tab, set_tab] = useState('null');
    const [search, set_search] = useState('');

    const [all_online, set_all_online] = useState(0);
    const [school_user_authentication, set_school_user_authentication] = useState(null)
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _read = (pages) => {

		let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (20 * pages) - 20 : 0
        
        }
        
        loading(true);

        API_GET_REQUEST('school/user/get__________?action=read'
            + '&limit=20'
            + '&offset=' + offsetSync
        , 
		).then((response) => {
            // console.log(JSON.stringify(response.data.data, undefined, 2))
            if(response.data.result == 'success'){
                set_data(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _search = () => {
        
        if(search.length > 3){
    
            API_GET_REQUEST('school/user/get__________?action=search'
                + '&search=' + search
            , 
            ).then((response) => {
                // console.log(JSON.stringify(response.data.data.list, undefined, 2))
                if(response.data.result == 'success'){
                    set_data(response.data.data)
                    error('')
                }else if(response.data.error){
                    error(response.data.error);
                    set_data(null)
                }
            })
            .catch((e) => {
                console.log('catch : ', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }

    }

    const _uploads = () => {

        if(file === null){
            return error('Tidak ada file')
        }

        if(loading === true){
            return
        }

        loading(true);

        var data = new FormData();
        data.append("sct", API_SCT);
        data.append("key", STORAGE_USER[0].id_key);

        file.map((item) => (
            data.append("file", item)
        ))

        var config = {
            method: 'post',
            url: API_URL + "/source/insert__________",
            headers: { 
                'Authorization': `Bearer ${STORAGE_TOKEN}`,
            },
            data : data,
            onUploadProgress: progressEvent => {
                console.log('loaded : ', progressEvent.loaded)
                console.log('total : ', progressEvent.total)
                progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
            }
        };

        axios(config)
        .then((response) => {
            if(response.data.result === 'success'){
                console.log('results : ', JSON.stringify(response.data));
                _read(pagination_active)
                set_file(null)
                error(response.data.title)
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        })
        .finally(() => {
			loading(false);
		})

    }
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Socket]
    ----------------------------------------------------------------*/
    const _socket = (storageUserParams) => {

        // all online ----------------------------------------------
        socket.on('all_online', (data) => {
            set_all_online(data.online)
		});
        
        // school user authentication ----------------------------------------------
        socket.on('school_user_authentication', (data) => {
            set_school_user_authentication(data.data)
		});

        socket.emit("school_user_authentication", {
            action: 'connect',
            room: 'room_school_user_authentication',
            status: 'online',
            bamboo_user : storageUserParams.bamboo,
            username : storageUserParams.username,
            name : storageUserParams.name,
            url_photo : storageUserParams.path + '/' + storageUserParams.photo,
            e_account : storageUserParams.e_account,
        });
        
	}

    const _socket_offline = () => {

        socket.emit("school_user_authentication", {
            action: 'disconnect',
            room: 'room_school_user_authentication',
            status: 'offline',
            bamboo_user : STORAGE_USER[0].bamboo,
            username : STORAGE_USER[0].username,
            name : STORAGE_USER[0].name,
            e_account : STORAGE_USER[0].e_account,
        });

    }
    /*--------------------------------------------------------------
    [End Socket]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 2048000){
                return error('Ukuran File maxsimal 2MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Storage User]
    ----------------------------------------------------------------*/
    const _STORAGE_USER = () => {

        let storage_bamboo = STORAGE_USER[0].bamboo;
        
        if(storage_bamboo){
            set_bamboo_user(storage_bamboo)
            _socket(STORAGE_USER[0])
        }

    }
    /*--------------------------------------------------------------
    [End Storage User]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        _STORAGE_USER()

    }, [refresh, search])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    return (
        <>

            <Helmet>

                <meta name="description" content={'school Admin Panel'}/>
                <title>{'school Admin Panel'}</title>

            </Helmet>

            <div className="_fmc_circle">
                <div className="_item"></div>
                <div className="_item"></div>
                <div className="_item"></div>
                <div className="_item"></div>
                <div className="_item"></div>
                <div className="_item"></div>
                <div className="_item"></div>
                <div className="_item"></div>
                <div className="_item"></div>
                <div className="_item"></div>
                <div style={{paddingTop: '18%'}}>

                    <div className="_lily_pad_h_d _relative">
                        <div className="_row _center_align _push_b_d">
                            <ion-icon name="leaf-outline" style={{fontSize: 20}}></ion-icon>
                            <p className="_push_l_m">Welcome</p>
                        </div>

                        <div className="_row _center_align">
                            <div className="_column">
                                <div className="_heading_bold _push_b_l" style={{maxWidth: 700}}>
                                    <span style={{color: '#118ab2'}}>e-</span>School Admin Panel : <span className="_grey">Untuk Kendali Dari Semua Aplikasi.</span>
                                </div>
                                <div className="_row _center_align">
                                    <div className="_push_r_s">
                                        <ion-icon name="git-merge-outline" style={{fontSize: 30, marginBottom: -2}}></ion-icon>
                                    </div>
                                    <div className="_column">

                                        <div className="_fmc_user_online">
                                            {
                                                school_user_authentication && school_user_authentication.list.map((item, index) => (
                                                    <div key={index} className="_item_user_online">
                                                        <div className={item.status === 'online' ? '_item_user_online_bullet_active' : '_item_user_online_bullet_deactive'}>

                                                        </div>
                                                        <div className="_item_user_online_name">
                                                            {item.name.charAt(0)}<sub>{item.name.charAt(1)}</sub>
                                                            <div className="_item_user_online_name_tooltip">
                                                                {item.name}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                            {
                                                school_user_authentication && school_user_authentication.count > 8 &&
                                                <div className="_item_user_online">
                                                    <div className="_item_user_online_name">
                                                        +
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            {/* <div className="_bb_search _push_b_d" style={{backgroundColor: 'transparent'}}>
                <div className="_row _center_align">
                    <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                    <div className="_column">
                        <input 
                            placeholder="Cari" 
                            onChange={e => set_search(e.target.value)}
                            value={search}
                        />
                    </div>
                </div>
            </div>

            <div className="_overflow_x">
                <table className="_table">
                    <thead>
                        <tr>
                            <th style={{width: 60}}><ion-icon name="rocket-outline" style={{fontSize: 22}}></ion-icon></th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>e_account</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data ? 
                                data.list.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{decode(item.name)}</td>
                                        <td>{decode(item.email)}</td>
                                        <td>{item.e_account === null ? 'e_test' : decode(item.e_account)}</td>
                                    </tr>
                                ))

                            :
                                data &&
                                <tr>
                                    <td colSpan="10">Belum Ada Data</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
            
            <div className="_lily_pad_h_d _push_b_d _push_t_d">
                <div className="__pagination">
                    {
                        data&&data.pages.map((item, index) => {
                            if(data.pages.length > 1){
                                return (

                                    <div 
                                        key={index} 
                                        className="__item"
                                        style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                        onClick={() => {
                                            _read(index + 1);
                                            set_pagination_active(index + 1)
                                        }}
                                    >
                                        <div className="_position_middle">
                                            {item}
                                        </div>
                                    </div>
                                    
                                )
                            }
                        })
                    }
                </div>
            </div> */}

        </>
    );

}

export default Screen;